import React from 'react';
import ReportTemplate from '../ReportTemplate';
import { formatDate, formatDollar } from '../../Utilities/GridTools';

// Helper function to handle null values
const handleNull = (params, formatter) => {
    if (params.value == null || params.value === '') {
        return 'N/A'; // or '-' or '' or whatever you prefer
    }
    return formatter ? formatter(params) : params.value;
};

const PTP5Days = () => {
    const columnDefs = [
        { headerName: 'Collector', field: 'collector', valueFormatter: (params) => handleNull(params) },
        { headerName: 'Debtor ID', field: 'debtorid', valueFormatter: (params) => handleNull(params) },
        { headerName: 'List Date', field: 'listdate', valueFormatter: (params) => handleNull(params, formatDate), filter: 'agDateColumnFilter' },
        { headerName: 'First Name', field: 'claimantName1First', valueFormatter: (params) => handleNull(params) },
        { headerName: 'Last Name', field: 'claimantName1Last', valueFormatter: (params) => handleNull(params) },
        { headerName: 'Adverse', field: 'adverseCarrier', valueFormatter: (params) => handleNull(params) },
        { headerName: 'Vehicles', field: 'vehCount', filter: 'agNumberColumnFilter', valueFormatter: (params) => handleNull(params) },
        { headerName: 'Limit', field: 'limit', valueFormatter: (params) => handleNull(params, formatDollar) },
        { headerName: 'Loss State', field: 'stateOfLoss', valueFormatter: (params) => handleNull(params) },
        { headerName: 'city', field: 'city', valueFormatter: (params) => handleNull(params) },
        { headerName: 'PRPTY', field: 'prpty', filter: 'agBooleanFilter' },
        { headerName: 'Vehicle', field: 'vehicleMake', valueFormatter: (params) => handleNull(params) },
        { headerName: 'Year', field: 'yr', filter: 'agNumberColumnFilter', valueFormatter: (params) => handleNull(params) },
        { headerName: 'Principle', field: 'principle', valueFormatter: (params) => handleNull(params, formatDollar) },
        { headerName: 'PTP Amt', field: 'ptpAmt', valueFormatter: (params) => handleNull(params, formatDollar) },
        { headerName: 'PTP Date', field: 'ptpDate', valueFormatter: (params) => handleNull(params, formatDate), filter: 'agDateColumnFilter' },
        { headerName: 'Second Note', field: 'secondNoticeCL', filter: 'agBooleanFilter' },
        { headerName: 'Police Report', field: 'policeReport', filter: 'agBooleanFilter' }
    ];

    const defaultColDef = {
        sortable: true,
        filter: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        resizable: true
    };
    const apiUrl = `${process.env.REACT_APP_API_URL}/Reports/Contribution/PTPFiveDays`;

     return (
        <ReportTemplate 
            columnDefs={columnDefs} 
            defaultColDef={defaultColDef}
            apiUrl={apiUrl} 
            reportName={'PTP 5 Days'} 
        />
    );
};

export default PTP5Days;